import React, { FC, useEffect, useState } from "react"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
import { RouteComponentProps, Link } from "@reach/router"
import { navigate } from '@reach/router'
// Components
import { Toolbar } from "components/subnav"
// Data
import api_match from "data/interface/api"
import assetListService from "data/asset-list"
import keyService, * as chord from "data/key"
import portfolioAssetService from "data/portfolio-asset"
import portfolioService from "data/portfolio"
// Styles
import { HeaderIcon_s } from 'components/wrapper/header/header-styles'
import { DetailedRouteUpDown_s, DetailedUpDownBtn_s } from "components/table/data-table-styles"
// Icons
import { CaretRightIcon, BackArrowIcon } from 'images/icons/general/'
import { CaretDownIcon, CaretUpIcon } from "images/icons/tools/"
import AssetSelectionDetailed from "../controls/asset-selection-detailed"

const PortfolioAssetDetail: FC<RouteComponentProps> = (props) => {

  const [currentPortfolio, setcurrentPortfolio] = useState<object|null>(null)
  const [portfolios, setPortfolios] = useState<object[]|null>(null)
  const [portfolioAssets, setPortfolioAssets] = useState<object[]|null>(null)
  const [assets, setAssets] = useState<object[]>([])

  useEffect(() => {

    const portfolioSubscription = portfolioService.stream().subscribe(data => {
      if (data.state === "ok"){
        setPortfolios(data.value)
        setcurrentPortfolio(_.find(data.value, {portfolioid: _.toNumber(_.get(props, "portfolioId"))}))
      }
    })

    const portfolioAssetSubscription = portfolioAssetService.stream().subscribe(data => {
      api_match(
        data,
        init  => init.value,
        ok    => {
          setPortfolioAssets(ok.value)
        },
        err   => {
          setPortfolioAssets(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const assetListSubscription = assetListService.stream().subscribe(data => {
      api_match(
        data,
        init  => setAssets(init.value),
        ok    => {
          setAssets(ok.value)
        },
        err   => {
          setAssets(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    assetListService.fetchAssets()
    portfolioAssetService.fetchOne(_.toNumber(_.get(props, "portfolioId")))
    portfolioService.fetchPortfolios()

    return function cleanup() {
      assetListSubscription.unsubscribe()
      portfolioSubscription.unsubscribe()
      portfolioAssetSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_UP && k.down === true:
          togglePortfolio('up')
          break
        case k.chord === chord.CTRL_SHIFT_DOWN && k.down === true:
          togglePortfolio('down')
          break
        case k.chord === chord.CTRL_SHIFT_BACK && k.down === true:
          navigate('/n/asset-management/portfolios')
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  })

  function togglePortfolio(direction:string):void {
    const currentPortfolioIdx       = portfolios?.indexOf(currentPortfolio!);
    let   nextPortfolio:object|null = null
    if (direction === 'up' && portfolios){
      nextPortfolio = portfolios && portfolios[currentPortfolioIdx! - 1]
    } else {
      nextPortfolio = portfolios && portfolios[currentPortfolioIdx! + 1]
    }
    if (nextPortfolio) setcurrentPortfolio(nextPortfolio)
    nextPortfolio && portfolioAssetService.fetchOne(nextPortfolio['portfolioid'])
  }

  const upDisabled   = !portfolios || _.isNil(portfolios[portfolios.indexOf(currentPortfolio!) - 1]) || (!_.isNil(portfolios) && currentPortfolio && portfolios[portfolios.indexOf(currentPortfolio!) - 1]['systeminput']?.startsWith('system'))
  const downDisabled = !portfolios || _.isNil(portfolios[portfolios.indexOf(currentPortfolio!) + 1]) || (!_.isNil(portfolios) && currentPortfolio && portfolios[portfolios.indexOf(currentPortfolio!) + 1]['systeminput']?.startsWith('system'))
  
  return (
    <div>
      <Toolbar>
        <div>
          <Link to="/n/asset-management/portfolios">
            <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={BackArrowIcon} /></HeaderIcon_s>
            Portfolio
          </Link>
          <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={CaretRightIcon} /></HeaderIcon_s>
          <div>Select Assets</div>
          <DetailedRouteUpDown_s>
            <DetailedUpDownBtn_s id="detailedRouteRecordUp" disabled={upDisabled} onClick={()=>togglePortfolio('up')}><Isvg src={CaretUpIcon} /></DetailedUpDownBtn_s>
            <DetailedUpDownBtn_s id="detailedRouteRecordDown" disabled={downDisabled} onClick={()=>togglePortfolio('down')}><Isvg src={CaretDownIcon} /></DetailedUpDownBtn_s>
          </DetailedRouteUpDown_s>
          <div>{_.get(currentPortfolio, "code")}</div>
        </div>
      </Toolbar>
      { currentPortfolio && assets.length && portfolioAssets && portfolioAssets && <AssetSelectionDetailed currentPortfolio={currentPortfolio} assets={assets} portfolioAssets={portfolioAssets} /> }
    </div>
  )

}

export default PortfolioAssetDetail